
import React from 'react';

const EarthBlueUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='64'
			height='65'
			fill='none'
			viewBox='0 0 64 65'
		>
			<g fill='#7BDBDC' clipPath='url(#clip0)'>
				<path d='M32 52.008c13.24 0 24-10.76 24-24 0-6.9-2.94-13.1-7.62-17.48v-.22l-.28-.02c-4.26-3.9-9.9-6.28-16.1-6.28-13.24 0-24 10.76-24 24s10.76 24 24 24zm20-24c0 3.26-.8 6.32-2.18 9.04-1.54-.68-3.08-1.5-3.44-1.88-.34-.6-.78-2.82-1.04-10.1l-.02-.58c-.12-3.36-4.22-4.54-6.66-5.26-.22-.06-.42-.12-.6-.18.12-.66.5-1.56.8-1.8.32-.2 1.32-.24 2.14-.26 1.12-.04 2.4-.1 3.76-.44 1.14-.3 1.9-.86 2.42-1.52 3 3.5 4.82 8.02 4.82 12.98zM27.42 8.548c.44.1.56.26.88.72.14.22.3.44.52.7-.28.28-.76.72-1.62 1.3-1.24.84-1.88 1.8-2.44 2.64-.44.64-.78 1.16-1.4 1.64-.82.66-2.74 1.4-4.02 1.9-1.64.64-2.32.9-2.8 1.5-.68.84-.64 1.98.08 3.62 1.14 2.5 3.56 5.24 6.96 5.4 3.2.16 5.36 1.34 6.08 1.88.3.68.74 3.54-1.26 5.62-1.46 1.5-3.72 3.84-5.06 4.76-.42-1.62-.74-4.9-.74-6.8 0-1.58-1.34-3.36-3.5-6.12-.68-.86-1.6-2.04-1.8-2.46-.66-1.4-2.04-2.78-2.94-3.7-.2-.18-.36-.36-.46-.46-.1-.16-.22-.3-.34-.44 2.46-5.82 7.6-10.22 13.86-11.7zm-15.14 16.22c.56.6 1.14 1.28 1.38 1.78.36.78 1.1 1.74 2.28 3.22.88 1.1 2.48 3.16 2.66 3.66 0 2.94.3 9.88 3.02 10.98.36.14.74.22 1.12.22 2.22 0 4.7-2.44 8.5-6.36 2.44-2.52 2.7-5.54 2.64-7.12-.02-.7-.2-3.04-1.48-4.16-1.14-1.02-4.26-2.78-8.66-3-1.5-.08-2.68-1.58-3.28-2.68.1-.04.22-.08.32-.12 1.68-.66 3.78-1.46 5.08-2.48 1.1-.86 1.72-1.8 2.22-2.54.46-.68.78-1.16 1.38-1.58 2.4-1.64 3.52-3.04 3.64-4.52.06-.74-.18-1.46-.66-2.04 4.44.1 8.52 1.66 11.8 4.2-.1.32-.26.38-.5.44-.94.24-1.94.28-2.92.32-1.44.06-2.82.12-4.02.84-1.68 1.02-2.76 3.66-2.78 5.56-.02 1.74.82 2.54 1.34 2.88.52.32 1.22.54 2.18.82.86.24 3.46 1 3.78 1.56l.02.56c.28 8.08.78 11.24 2 12.56.92 1 2.8 1.98 4.28 2.68-3.66 4.6-9.3 7.56-15.62 7.56-11.02 0-20-8.98-20-20 0-1.1.12-2.18.28-3.24zM52 60.008H12v4h40v-4z'></path>
			</g>
			<defs>
				<clipPath id='clip0'>
					<path
						fill='#fff'
						d='M0 0H64V64H0z'
						transform='translate(0 .008)'
					></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default EarthBlueUnderline;
